import React from "react";

const SendButton = ({ text, onClick, size }) => {
  return (
    <button
      onClick={onClick}
      className={`px-4 py-1 rounded-full text-nowrap bg-[#0c8a36] text-white ${
        size === "sm" ? "text-xs" : "text-sm"
      } scale-100 hover:scale-105 transition-all duration-300`}
    >
      {text}
    </button>
  );
};

export default SendButton;
